import { Menu, Transition } from "@headlessui/react";
import { forwardRef, Fragment, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DateFilter({
  startDate,
  endDate,
  handleChange,
  onChange,
  setIsOpenFil,
  isOpenFil,
}) {
  const [filterVal, setFilter] = useState({
    value: "this_week",
    label: "This Week",
  });

  const options = [
    { value: "this_week", label: "This Week" },
    { value: "this_month", label: "This Month" },
    { value: "this_quarter", label: "This Quarter" },
    { value: "this_year", label: "This Year" },
    { value: "custom_date", label: "Custom Date" },
  ];

  const toggleClass = () => {
    const bodyElement = document.getElementsByClassName("dropdown-btn")[0];
    if (bodyElement && bodyElement.classList) {
      if (bodyElement.classList.contains("open")) {
        bodyElement.classList.remove("open");
      } else {
        bodyElement.classList.add("open");
      }
    }
  };

  const CustomInput = forwardRef(({ value, onClick }, ref) => {
    const handleClick = () => {
      onClick();
      setFilter({ value: "custom_date", label: "Custom Date" });
      // handleFilter("custom");
    };

    return (
      <button
        className="text-sm text-brand-text-dark font-montserrat font-medium block px-3 py-2 hover:bg-gray-100 w-full text-left"
        type="button"
        onClick={handleClick}
        ref={ref}
      >
        Custom date
      </button>
    );
  });

  return (
    <div className="dropdown-btn">
      <Menu as="div">
        <button
          className="button"
          onClick={() => {
            toggleClass();
            setIsOpenFil(!isOpenFil);
          }}
        >
          {filterVal.label}
        </button>

        <Transition
          className="dropdown"
          show={isOpenFil}
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items>
            <div className="py-1">
              {options.map((option, i, array) => {
                if (i + 1 === array.length) {
                  return (
                    <ReactDatePicker
                      selected={startDate}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={onChange}
                      customInput={<CustomInput />}
                      selectsRange
                      maxDate={new Date()}
                    />
                  );
                } else {
                  return (
                    <button
                      type="button"
                      onClick={() => {
                        setFilter(option);
                        handleChange(option);
                        setIsOpenFil(false);
                      }}
                    >
                      {option.label}
                    </button>
                  );
                }
              })}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
